import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DetailedRecipeModel } from 'hx-services';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {
  limit = 100;

  constructor(
    private _http: HttpClient,
  ) { }

  getRecipe(id: number): Promise<DetailedRecipeModel[]> {
    return firstValueFrom(this._http.get<DetailedRecipeModel[]>(`/api/vn/recipes/detailed?stepId=${id}`));
  }

  sendProcess(body?: {userId?: number, workflowId?: number, workflowStepId?: number, totalAmount?: number}): Promise<void> {
    return firstValueFrom(this._http.post<void>(`/api/vn/cf/process`, body));
  }

  sendProcessWorkflow(body?: {userId?: number, workflowId?: number, totalAmount?: number}): Promise<void> {
    return firstValueFrom(this._http.post<void>(`/api/vn/cf/process/by-workflow`, body));
  }

  getWorkflowStep(workflowId: number): Promise<any> {
    return firstValueFrom(this._http.get(`/api/vn/workflows/${workflowId}/steps?limit=${this.limit}`));
  }
}
